module.exports = __webpack_public_path__ + "static/PruszczGdanski-4d5d3e86173699014cf8bae5babb257f.svg";